export default "__VITE_ASSET__0f1adcf7__"